require('./regular/index');
require('./modules/index');



// WEBPACK FOOTER //
// ./resources/js/app.js